import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {Link, Route, Switch} from 'react-router-dom';

import '../../style/Topbar.scss';
import {FormattedMessage, injectIntl} from "react-intl";
import {Mutation, Query} from "react-apollo";
import queries from "../../queries";
import {backEndUri} from '../../config';
import NeedAuth from "../NeedAuth";
import confirmDialog from "../dialogs/ConfirmDialog";
import NeedAdmin from "../NeedAdmin";
import { showToast } from '../../toast';
import { t, tn } from '../../i18n';
import { canUserPublish } from '../../utils';
import PublicationHistory from '../projects/PublicationHistory';
import SaveIndicator from './SaveIndicator';
import { apolloClient } from '../../config';


class Topbar extends Component {

  state = {confirmShow: false}

  publishDialogConfirmationContent = (
    <FormattedMessage id={'project.publish.dialog.message'} values={{br: <br/>}} />
  );

  // Résumé affiché avant de publier : ce qui part en ligne et quels écrans seront mis à jour.
  askPublish = async (projectId) => {
    let summary = null;
    try {
      const { data } = await apolloClient.query({ query: queries.projects.publishSummary, variables: { id: projectId }, fetchPolicy: 'network-only' });
      summary = data.project;
    } catch (e) { /* on retombe sur le message générique */ }
    const devices = (summary && summary.devices) || [];
    const content = summary ? (
      <div className='tsk-publish-summary'>
        <p>{t('ui.pub.summary.intro', { name: summary.name })}</p>
        <ul>
          <li>{tn('ui.pub.summary.pages', (summary.pages || []).length, { names: (summary.pages || []).map((p) => p.name).join(', ') || '—' })}</li>
          <li>
            {devices.length === 0
              ? t('ui.pub.summary.no_screens')
              : tn('ui.pub.summary.screens', devices.length, { names: devices.map((d) => d.name || d.location || d.id).join(', ') })}
          </li>
          {devices.some((d) => !d.connected) && (
            <li className='tsk-publish-summary__warn'>
              {t('ui.pub.summary.offline', { names: devices.filter((d) => !d.connected).map((d) => d.name || d.location || d.id).join(', ') })}
            </li>
          )}
          <li>{summary.latest_version ? t('ui.pub.summary.version', { current: summary.latest_version.version, next: summary.latest_version.version + 1 }) : t('ui.pub.summary.first')}</li>
        </ul>
        <p>{t('ui.pub.summary.outro')}</p>
      </div>
    ) : this.publishDialogConfirmationContent;
    return confirmDialog(content, { confirmLabel: t('ui.pub.confirm_label') });
  };

  render() {
    const {identityProvider, intl} = this.props;
    return (
      <div className='tsk-topbar'>
        <NeedAuth identityProvider={identityProvider} showLoginButton={false}>
          <div className='tsk-topbar-title'>
            <Switch>
              <Route exact path='/project' render={ () =>
                <span>
                  <FormattedMessage id='projects.title'/>
                </span>
              } />
              <Route exact path='/admin/users' render={ () => <span><FormattedMessage id='admin.users.title'/></span> } />
              <Route exact path='/admin/activity' render={ () => <span>{t('ui.activity.title')}</span> } />
              <Route exact path='/admin/displays' render={ () => <span><FormattedMessage id='admin.displays.title'/></span> } />
              <Route exact path='/project/new' render={ () =>
                <span>
                  <FormattedMessage id='projects.new.title'/>
                </span>
              } />
              <Route path='/project/:projectId' render={ ({match}) => {
                const { projectId } = match.params;
                return <Query query={queries.projects.get} variables={{ id: projectId }}>
                  {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) return `Error!: ${error}`;

                    const { project } = data;
                    return (
                      <span>{project.name}</span>
                    )
                  }}
                </Query>
              }} />
              <Route path='/admin/displaysGroup/:groupId' render={({match})=>{
                const {groupId} = match.params;
                return (groupId !== "bureau" && groupId !== "all" && groupId !== 'noname') ? (
                <Query query={queries.displays.listByGroup} variables={{id: groupId}}>
                  {({loading, error, data})=>{
                    if(loading){
                      return null;
                    }
                    if(error){
                      return error.message;
                    }
                    const group = data.devicesGroup;
                    return(
                      <>
                      <span>
                        {group.name}
                      </span>
                      <Mutation mutation={queries.displays.deleteGroup}>
                       {(remove)=>{
                           return(
                            <button
                              className={'tsk-button tsk-warning'}
                              onClick={() => {
                              confirmDialog('Delete this group now').then(res => {
                            apolloClient.mutate({
                            mutation: queries.displays.deleteGroup,
                            variables: {id: groupId},
                            refetchQueries: [{query: queries.displays.listGroup}]
                          }).then((res) => {
                            if(!res.errors && res.data) {
                              window.location.href  = '/admin/displays';
                            }
                          });
                        });
                      }}>
                        <FormattedMessage id={'common.button.delete'} />
                        </button>
                           )
                         }}
                      </Mutation>
                       </>
                    )
                  }}
                </Query>
                )
                :
                <span>
                  {groupId}
                </span>
              }}/>
            </Switch>
          </div>
          <div className='tsk-topbar-content'>
            <Switch>
              <Route exact path='/project' render={ () =>
                <NeedAdmin trueAdmin>
                  <div />
                  <Link className='tsk-link tsk-upper tsk-topbar-primary' to={'/project/new'}>
                    <FormattedMessage id='projects.create.button' />
                  </Link>
                </NeedAdmin>
              } />
              <Route path='/project/new' />
              <Route path='/project/:projectId/tabMenu' render={ ({match}) =>
                <div>
                  <FormattedMessage id='project.tabmenus.title' />
                </div>
              } />
              <Route path='/project/:projectId' render={ ({match}) => {
                const { projectId } = match.params;
                return <Query query={queries.projects.get} variables={{ id: projectId }}>
                  {({ loading, error, data }) => {
                    if (loading) return null;
                    if (error) return `Error!: ${error}`;

                    const { project } = data;
                    return (
                      <React.Fragment>
                        <div className={'tsk-grow'} />
                        <SaveIndicator />
                        <PublicationHistory projectId={projectId} latestVersion={project.latest_version} />
                        <NeedAdmin trueAdmin>
                          <a className={'tsk-link tsk-upper'} href={`${backEndUri}/project/${projectId}/stats`} download>
                            <FormattedMessage id='projects.stats.button' />
                          </a>
                        </NeedAdmin>
                        <button
                          className={'tsk-button tsk-link tsk-upper tsk-topbar-primary'}
                          disabled={!canUserPublish(identityProvider.currentUser())}
                          title={canUserPublish(identityProvider.currentUser()) ? undefined : t('ui.pub.err403')}
                          onClick={() => {
                          this.askPublish(projectId).then(async () => {
                            const publishUri = `${backEndUri}/project/${projectId}/publish`;
                            const dismiss = showToast(t('ui.pub.in_progress'), 'info', 0);
                            let token;
                            try { token = await identityProvider.currentUser().jwt(); } catch (e) { /* sans jeton */ }
                            fetch(publishUri, { headers: token ? { Authorization: `Bearer ${token}` } : {} })
                              .then(async (response) => {
                                const body = await response.json().catch(() => ({}));
                                if (!response.ok) throw new Error(response.status === 401 ? t('ui.pub.err401') : response.status === 403 ? t('ui.pub.err403') : t('ui.pub.failed'));
                                return body;
                              })
                              .then(jsResponse => {
                                dismiss();
                                console.log(JSON.stringify(jsResponse));
                                showToast(t('ui.pub.done'));
                                apolloClient.query({ query: queries.projects.get, variables: { id: projectId }, fetchPolicy: 'network-only' }).catch(() => {});
                                setTimeout(() => apolloClient.query({ query: queries.projects.publishState, variables: { id: projectId }, fetchPolicy: 'network-only' }).catch(() => {}), 4000);
                              })
                              .catch((error) => {
                                dismiss();
                                showToast(error.message || t('ui.pub.failed'), 'error', 7000);
                              });
                          });
                        }}>
                          <FormattedMessage id='projects.publish.button' />
                        </button>
                        <NeedAdmin trueAdmin>
                          {project.latest_version && (
                            <a className={'tsk-link tsk-upper'} href={project.latest_version.uri} download>
                              <FormattedMessage id='projects.download.button' />
                            </a>
                          )}
                          {!project.latest_version && (
                            <button className={'tsk-button tsk-link tsk-upper'} onClick={() => {
                              const alertMessage = intl.formatMessage({id: 'project.download.nonpublished.dialog.message'});
                              alert(alertMessage);
                            }}>
                              <FormattedMessage id='projects.download.button' />
                            </button>
                          )}
                        </NeedAdmin>
                        <button className={'tsk-button tsk-link tsk-upper'} onClick={() => {
                          window.open(`/project/${projectId}/preview`, 'treeosk-preview', 'height=640,location=no,menubar=no,resizable=no,scrollbars=yes,status=yes,titlebar=no,toolbar=no,width=360');
                        }}>
                          <FormattedMessage id='projects.preview.button' />
                        </button>
                      </React.Fragment>
                    )
                  }}
                </Query>
              }} />
            </Switch>
          </div>
        </NeedAuth>
      </div>
    );
  }
}

Topbar.propTypes = {
  identityProvider: PropTypes.object.isRequired,
};

export default injectIntl(Topbar);
